import { ChangeDetectionStrategy, Component, OnInit } from "@angular/core";
import { LoaderService } from "../shared/services/loader.service";

@Component({
	selector: "app-spinner",
	templateUrl: "./spinner.component.html",
	styleUrls: ["./spinner.component.scss"],
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false,
})
export class SpinnerComponent implements OnInit {
	constructor(public loader: LoaderService) {}

	ngOnInit(): void {}
}
